export default "__VITE_ASSET__cab46b9d__"